module.exports = __webpack_public_path__ + "img/fm-whatsapp-logo.d9a51884.webp";